import { toQR } from "toqr";

// Offline QR-as-SVG renderer, lifted from scripts/qr-kit/generate-qr-kit.ts (the canonical
// copy - keep the rendering logic in sync; that file is node:fs-coupled so the pure path is
// duplicated here for the browser bundle). Error-correction level M, 4-module quiet zone.
// The payload lives ONLY in the module matrix - never as readable text, attribute, href,
// or URL - so a printed kit leaks nothing greppable. No network QR service, ever.

const QR_EC_LEVEL_M = 0;
const QR_QUIET_ZONE_MODULES = 4;

export function renderQrSvg(payload: string): string {
  const matrix = toQR(payload, QR_EC_LEVEL_M);
  const size = Math.round(Math.sqrt(matrix.length));
  if (size <= 0 || size * size !== matrix.length) {
    throw new Error(`toqr returned a non-square matrix (length ${matrix.length})`);
  }

  const quiet = QR_QUIET_ZONE_MODULES;
  const dim = size + quiet * 2;
  let modules = "";
  for (let y = 0; y < size; y++) {
    let x = 0;
    while (x < size) {
      if (matrix[y * size + x] === 1) {
        let run = 1;
        while (x + run < size && matrix[y * size + x + run] === 1) {
          run++;
        }
        modules += `<rect x="${x + quiet}" y="${y + quiet}" width="${run}" height="1"/>`;
        x += run;
      } else {
        x++;
      }
    }
  }

  return `<svg class="qr-svg" viewBox="0 0 ${dim} ${dim}" width="100%" height="100%" shape-rendering="crispEdges" role="img" aria-label="Checkpoint QR code"><rect width="${dim}" height="${dim}" fill="#ffffff"/><g fill="#000000">${modules}</g></svg>`;
}
